import { render, staticRenderFns } from "./PatentSection.vue?vue&type=template&id=3d59f46a&scoped=true"
import script from "./PatentSection.vue?vue&type=script&lang=js"
export * from "./PatentSection.vue?vue&type=script&lang=js"
import style0 from "./PatentSection.vue?vue&type=style&index=0&id=3d59f46a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d59f46a",
  null
  
)

export default component.exports